<ng-template #loaderBlock>
  <app-loader></app-loader>
</ng-template>
<div class="engagement-summary">
    <div>
      
      <div class="scrollTable">
        <motif-accordion
            togglePosition="after"
            type="default"
            hideToggle="false"
            [multi]="false">
            <motif-expansion-panel size="small"  *ngFor="let engagement of engagements | keyvalue">
              <motif-expansion-panel-header role="button" [alternativeTriggerIcon]="false">
                <motif-panel-title>{{ engagement.key }}</motif-panel-title>
              </motif-expansion-panel-header>
                <table>
                  <tbody>
                    <tr class="engagementTr" *ngFor="let item of engagement.value" (click)="openDetailsModal(item.name)">
                      <td>{{ item?.name }}</td>
                      <td>
                        <div class="view-button">
                          <img src="/assets/images/nav-arrow-right.svg" />
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
            </motif-expansion-panel>
          </motif-accordion>
      </div>
    </div>
    <ng-container *ngIf="!loading; else loaderBlock"> </ng-container>
</div>
